import { StorageSerializers, useStorage } from '@vueuse/core'

export const currentOrder =
  useStorage('f4cOrder', null, window.sessionStorage, { serializer: StorageSerializers.object })
